import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createCategory, updateCategory, clearMessages } from '../../../redux/slices/admin/videoSlice';

const CategoryModal = ({ isOpen, closeModal, initialData, isEditMode }) => {
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({
        title: ''
    });

    // Messages from the Redux state
    const errorMessage = useSelector((state) => state.admin_videos?.error);

    // Populate form data for editing
    useEffect(() => {
        if (isEditMode && initialData) {
            setFormData({
                title: initialData.title || ''
            });
        }
    }, [isEditMode, initialData]);

    // Update form data on input change
    const handleFormChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
    };
 
    // Handle form submission
    const handleSubmit = async (event) => {
        event.preventDefault();
        const form = new FormData();
        form.append('title', formData.title);
        form.append('id', isEditMode ? initialData.id : undefined);

        if (isEditMode) {
            await dispatch(updateCategory({'id':'', 'categoryData':form}));
        } else {
            await dispatch(createCategory({'id':initialData.id, 'categoryData':form}));
        }
    };

    // Close modal and clear messages
    const handleClose = () => {
        dispatch(clearMessages());
        setFormData({
            title: ''
        });
        closeModal();
    };

    if (!isOpen) return null;

    return (
        <div className="modal fade show" id="modalNutritionRecipes" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="createBackdropLabel" aria-modal="true" role="dialog" style={{ display: 'block', paddingLeft: '0px' }}>
            <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-create">
                <div className="modal-content">
                    <div className="modal-header justify-content-center">
                        <h1 className="modal-title" id="createBackdropLabel">{isEditMode ? 'Edit Category' : 'Create Category'}</h1>
                        <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"></button>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="modal-body">
                            <div className="row g-3 gx-md-5 gy-md-4">
                                <div className="col-md-12">
                                    <input
                                        type="text"
                                        name="title"
                                        placeholder="Category Name"
                                        className="form-control form-control-lg"
                                        value={formData.title}
                                        onChange={handleFormChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-12">
                                    <button type="submit" className="btn btn-create w-100">{isEditMode ? 'Update' : 'Create'}</button>
                                </div>

                                <div className="col-md-12">
                                    {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CategoryModal;